import React from "react";

const DepartmentToolbar = ({
    filters,
    onChange,
    officeOptions,
    onReset,
}) => {

    const inputStyle = {
        padding: "10px 14px",
        border: "1px solid #d1d5db",
        borderRadius: "10px",
        outline: "none",
        fontSize: "14px",
        background: "#fff",
    };

    return (
        <div
            style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
                alignItems: "center",
                marginBottom: "24px",
            }}
        >
            <input
                type="text"
                placeholder="Search department..."
                value={filters.search}
                onChange={(event) =>
                    onChange({
                        ...filters,
                        search: event.target.value,
                    })
                }
                style={{
                    ...inputStyle,
                    flex: 1,
                    minWidth: "260px",
                }}
            />

            <select
                value={filters.office}
                onChange={(event) =>
                    onChange({
                        ...filters,
                        office: event.target.value,
                    })
                }
                style={inputStyle}
            >
                <option value="">
                    All Offices
                </option>

                {officeOptions.map((office) => (
                    <option
                        key={office}
                        value={office}
                    >
                        {office}
                    </option>
                ))}
            </select>

            <select
                value={filters.status}
                onChange={(event) =>
                    onChange({
                        ...filters,
                        status: event.target.value,
                    })
                }
                style={inputStyle}
            >
                <option value="">All Statuses</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
            </select>

            <button
                type="button"
                onClick={onReset}
                style={{
                    padding: "10px 18px",
                    borderRadius: "10px",
                    border: "1px solid #d1d5db",
                    background: "#fff",
                    cursor: "pointer",
                    fontWeight: 600,
                }}
            >
                Reset
            </button>
        </div>
    );
};

export default DepartmentToolbar;
